<template>
  <div class="w-100">
    <Jumbotron :item="niche" :type="type" :name="nicheName" />
    <b-container fluid>
      <b-row>
        <b-col>
          <div v-if="isLoading" class="position-absolute w-100">
            <Loading />
          </div>
          <GridCSS v-else :items="nicheContent" :send-vector-click="true" @item-click="vectorClick">
            <template #default="slotProps">
              <NormalVectorOverlay :data="slotProps.data" />
            </template>
          </GridCSS>
          <GrouperPaginator
            :name-page="type"
            :total-pages="nicheTotalPages"
            :current-page="nicheCurrentPage"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import GridCSS from '@/components/Common/GridCSS';
import GrouperPaginator from '@/components/Groupers/GrouperPaginator';
import Jumbotron from '@/components/Common/Jumbotron';
import Loading from 'UI/Loading';
import NormalVectorOverlay from '@/components/Vectors/NormalVectorOverlay';

export default {
  components: {
    GridCSS,
    GrouperPaginator,
    Jumbotron,
    Loading,
    NormalVectorOverlay
  },
  computed: {
    ...mapState('niches', [
      'niche',
      'nicheContent',
      'nicheCurrentPage',
      'nicheTotalPages',
      'isLoading'
    ]),
    ...mapGetters('experience', ['isDesignActive']),
    nicheName() {
      return this.isDesignActive
        ? this.$t('main.groupers.topics.title')
        : this.$t('main.groupers.nitches.title');
    },
    type() {
      return this.isDesignActive ? 'topics' : 'niches';
    }
  },
  methods: {
    async vectorClick({ item, shownListing }, e) {
      e.preventDefault();
      this.$bvModal.show('preview-vector-modal');
      await this.$store.dispatch('vectors/OPEN_PREVIEW', { id: item.id, list: shownListing });
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 27px;
}
p {
  font-size: 16px;
}
.badge-secondary {
  background: #b8aea4;
}
</style>
